export interface CurrentAuthUser {
  userId?: number | string | null;
  username?: string | null;
  email?: string | null;
  role?: string | null;
  profile?: Record<string, unknown> | null;
}

const STORAGE_KEY = 'star_t_current_auth_user';
const LOGIN_MARKER_KEY = 'auth_username';

export const setCurrentAuthUser = (user: CurrentAuthUser | null) => {
  if (typeof window === 'undefined') return;
  if (!user) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(user));
};

/**
 * Clear every client-side marker used to render an authenticated session.
 * The API session itself is an httpOnly cookie; this only prevents the UI
 * from showing a stale identity after that cookie has expired or been revoked.
 */
export const clearCurrentAuthSession = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_KEY);
  window.localStorage.removeItem(LOGIN_MARKER_KEY);
};

export const getCurrentAuthUser = (): CurrentAuthUser | null => {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CurrentAuthUser;
  } catch {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const isCurrentAuthUserAdmin = (): boolean => getCurrentAuthUser()?.role === 'admin';
